import axiosPrivate from "../../../api/axiosPrivate";
import {
  CREATE_LIFE_COVER,
  GET_ALL_LIFE_COVER,
  UPDATE_LIFE_COVER,
  VIEW_LIFE_COVER,
} from "../../../api/constant";

// Create new role
const createLifeCover = async (data) => {
  const response = await axiosPrivate.post(CREATE_LIFE_COVER, data);
  return response.data;
};

const getAllLifeCover = async ({pageNum, search}) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_LIFE_COVER}?page=${pageNum}&search=${search}`
  );
  return response.data;
};

const getSingleLifeCover = async (id) => {
  const response = await axiosPrivate.get(`${VIEW_LIFE_COVER}/${id}`);
  return response.data;
};

const getUnpaginatedLifeCover = async () => {
  const response = await axiosPrivate.get(CREATE_LIFE_COVER);
  return response.data;
};

const updateLifeCover = async (data) => {
  const response = await axiosPrivate.post(
    `${UPDATE_LIFE_COVER}/${data.id}`,
    data
  );
  return response.data;
};

const lifecoverService = {
  createLifeCover,
  getAllLifeCover,
  getSingleLifeCover,
  updateLifeCover,
  getUnpaginatedLifeCover,
};
export default lifecoverService;
